
export default {
  props: {
    listName: {
      type: String,
      required: true,
    },
    showModal: {
      type: Boolean,
      required: true,
    },
  },

  methods: {
    close() {
      // emit close event
      this.$emit('close');
    },
    confirm() {
      // emit confirm event
      this.$emit('confirm');
    },
  },
};
